export var ValuationBlockValueAdjustmentHeadingEnum;
(function (ValuationBlockValueAdjustmentHeadingEnum) {
    ValuationBlockValueAdjustmentHeadingEnum["ValuationBlockId"] = "Valuation block ID";
    ValuationBlockValueAdjustmentHeadingEnum["Reasoning"] = "Reasoning";
    ValuationBlockValueAdjustmentHeadingEnum["AdjustmentValue"] = "Adjustment value";
})(ValuationBlockValueAdjustmentHeadingEnum || (ValuationBlockValueAdjustmentHeadingEnum = {}));
export const ValuationBlockValueAdjustmentConfigHeadingLookup = new Map([[ValuationBlockValueAdjustmentHeadingEnum.Reasoning, "reasoning"], [ValuationBlockValueAdjustmentHeadingEnum.AdjustmentValue, "adjustmentValue"]]);
